// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"525":"fc0caa09","606":"71730690","657":"e1b84d36","884":"565dcf01","970":"f3bb6d8a"}[chunkId] + ".chunk.js";
};